var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tabs',{attrs:{"grow":"","color":"white","background-color":"viortisLight"},model:{value:(_vm.selectedTab),callback:function ($$v) {_vm.selectedTab=$$v},expression:"selectedTab"}},_vm._l((_vm.tabs),function(product){return _c('v-tab',{key:product.id,attrs:{"tab-value":product.id}},[_c('span',[_vm._v(_vm._s(product.name))])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }